export default __webpack_public_path__ + "static/Commercial-Trash-Collection-1b65adb0d12740b2e0fd03a824814072.jpg";